export const toAbsoluteUrl = (pathname: string) => {
  return process.env.PUBLIC_URL + pathname
}
